// lib/services/animation/attachment.ts

import { identityMat4, multiplyMat4 } from "./anim_math";

export default abstract class Attachment {
  readonly name: string;
  readonly local_matrix: Float32Array;
  readonly world_matrix: Float32Array;
  readonly world_position: Float32Array;

  constructor(name: string, local_matrix?: Float32Array) {
    this.name = name;
    this.local_matrix = local_matrix ?? identityMat4();
    this.world_matrix = identityMat4();
    this.world_position = new Float32Array([0, 0, 0]);
  }

  protected apply_world_matrix(reference_matrix: Float32Array): void {
    const result = multiplyMat4(reference_matrix, this.local_matrix);
    this.world_matrix.set(result);

    this.world_position[0] = this.world_matrix[12];
    this.world_position[1] = this.world_matrix[13];
    this.world_position[2] = this.world_matrix[14];
  }

  abstract update(parent: any): void;
}